export const detail = (contact) => {
  if (contact.phones) {
    return contact.phones[0].number
  } else if (contact.email) {
    return contact.email[0].address
  } else {
    return ''
  }
}

export default (contact) => {
  if (contact) {
    return   contact.first_name || contact.middle_name || contact.last_name
    ? `${contact.first_name ? `${contact.first_name} ` : ''}${
        contact.middle_name ? `${contact.middle_name} ` : ''
      }${contact.last_name ? `${contact.last_name} ` : ''}`
    : detail(contact)
  }
  return 'Contact'
}